import {
    Button,
    Modal,
    ModalBody,
    ModalContent
} from "@heroui/react";

export default function BufferCreditWarningModal({
                                                     isOpen,
                                                     onOpenChange,
                                                     onConfirm,
                                                     isLoading = false
                                                 }) {
    return (
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        size="lg"
        hideCloseButton
        backdrop="blur"
        classNames={{
            base: "overflow-hidden rounded-3xl border border-[#12131714] bg-white shadow-2xl",
            body: "p-0",
        }}
      >
          <ModalContent>
              {(onClose) => (
                <ModalBody>
                    {/* Hero band — caution themed with a pulsing credits badge */}
                    <div className="relative overflow-hidden bg-gradient-to-br from-[#f59e0b] via-[#f5a623] to-[#fbbf24] px-8 pt-9 pb-12">
                        <div className="pointer-events-none absolute -top-10 -right-8 h-32 w-32 rounded-full bg-white/15 blur-2xl" />
                        <div className="pointer-events-none absolute -bottom-12 -left-6 h-32 w-32 rounded-full bg-white/10 blur-2xl" />

                        <div className="relative flex flex-col items-center text-center">
                            <div className="relative grid h-16 w-16 place-items-center">
                                <span className="absolute inset-0 rounded-2xl bg-white/30 animate-ping" />
                                <span className="relative grid h-16 w-16 place-items-center rounded-2xl bg-white/20 backdrop-blur-sm ring-1 ring-white/40">
                                    <i className="hgi-stroke hgi-coins-01 text-3xl text-white" />
                                </span>
                            </div>
                            <h2 className="mt-4 text-xl font-semibold text-white">Heads up — buffer credits used up</h2>
                            <p className="mt-1 max-w-sm text-sm font-light text-white/85">
                                From here on, charges come out of your main balance.
                            </p>
                        </div>
                    </div>

                    {/* Consequence note */}
                    <div className="px-6 pt-5">
                        <div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4">
                            <i className="hgi-stroke hgi-alert-02 mt-0.5 text-lg text-amber-500" />
                            <p className="text-sm font-light leading-relaxed text-amber-700">
                                You have used all of your buffer credits. Now, credits will be deducted from your
                                main credit balance. Would you like to continue?
                            </p>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="flex justify-end gap-3 px-6 py-5">
                        <Button
                          onPress={onOpenChange}
                          variant="bordered"
                          className="h-11 rounded-xl border-1 border-[#00000014] bg-[#c8ceda4d] px-6 text-sm font-medium text-slate-700 hover:border-slate-700"
                        >
                            Cancel
                        </Button>
                        <Button
                          isLoading={isLoading}
                          className="h-11 rounded-xl bg-[#7659fa] px-6 text-sm font-medium text-white shadow-lg shadow-[#7659fa40] transition hover:opacity-95"
                          onPress={onConfirm}
                        >
                            Confirm
                        </Button>
                    </div>
                </ModalBody>
              )}
          </ModalContent>
      </Modal>
    );
}
